import { defineAction } from '~/prix'
import variableAnalyzeAction from './variableAnalyze.action.json' with { type: 'json' }
import { z } from 'zod'

const variableAnalyzeDefinition = defineAction({
  ...variableAnalyzeAction,

  input: z.object({
    full: z.boolean().default(false),
    sectorFilter: z
      .union([z.array(z.string()), z.string()])
      .describe('Filtros de setor.')
      .nullish(),
    concurrency: z.number().int().min(1).max(16).optional(),
    filterGlob: z.string().trim().optional(),
  }),
  output: z.object({}),
})

export default variableAnalyzeDefinition
